module.exports = __webpack_public_path__ + "img/small-4.5293985c.webp";